import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const AdminsLinksLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "AdminsLinks" */
      './AdminsLinks.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
